<!-- eslint-disable vue/html-indent -->
<template>
  <div
    v-if="!job.retried"
    class="job-item d-flex align-items-center w-100 dropdown-item"
    :data-job-id="job?.id"
  >
    <ci-main-status
      v-if="job.status"
      class="mr-2"
      :icon-size="3"
      :only-icon="true"
      :status="job.status"
    />
    <a
      :href="
        '/project/' +
        (this.alias || $route.params.alias) +
        '/' +
        (this.projectAlias || $route.params.projectAlias) +
        '/ci-cd/job/' +
        job.localId
      "
      class="mr-2 text-nowrap text-secondary text-truncate"
    >
      {{ job.name }}
    </a>
    <span
      v-if="type"
      class="badge badge-success mr-1"
    >
      {{ type }}
    </span>
    <button
      type="button"
      v-if="showRepeat && getActionAvailabilityFlag(ACTION_ENUM.EXECUTE_CI_CD) && job.canBeRetried"
      :data-target="'restartJobModal-' + job.localId"
      class="btn btn-sm btn-outline-secondary job-item__repeat-button border ml-auto"
      @click="$emit('openModal', job.localId)"
    >
      <i class="gf-icon gf-icon-reload"></i>
    </button>
  </div>
</template>

<script>
import CiMainStatus from '@shared/modules/ci-cd/components/ci-main-status';
import CiCdService from '@shared/modules/ci-cd/ci-cd.service';
import ACTION_ENUM from '@shared/modules/custom-roles/custom-roles.constants';
import CiCdMessages from '@shared/modules/ci-cd/ci-cd.messages';

export default {
  name: 'CiPipelinesJobItemDropdown',
  computed: {
    ACTION_ENUM() {
      return ACTION_ENUM;
    }
  },
  components: { CiMainStatus },
  props: {
    job: {
      default: null,
      type: Object
    },
    iconsSize: {
      default: 1.8,
      type: Number
    },
    isLight: {
      default: false,
      type: Boolean
    },
    showRepeat: {
      default: true,
      type: Boolean
    },
    type: {
      default: null,
      type: String
    },
    alias: {
      default: null,
      type: String
    },
    projectAlias: {
      default: null,
      type: String
    },
    modalWidth: {
      type: String,
      default: '500px'
    },
    modalHeight: {
      type: String,
      default: 'auto'
    }
  },
  mounted() {},
  methods: {
    closeRestartJobModal() {
      this.$refs.gfCustomModalWindowRestartJob.closeModalWindow();
    },
    getActionAvailabilityFlag(action) {
      return this.$store.getters.getActionAvailabilityFlag(action);
    },
    restartJob() {
      CiCdService.startJob(
        this.alias || this.$route.params.alias,
        this.projectAlias || this.$route.params.projectAlias,
        this.job.localId
      )
        .then(() => {
          window.location.reload();
        })
        .catch((err) => {
          console.error(err);
        });
    }
  },
  i18n: {
    messages: CiCdMessages
  }
};
</script>

<style lang="scss" scoped>
.job-item {
  &.--highlighted {
    background-color: var(--bg-light);
  }

  &__repeat-button {
    display: inline-flex;
    padding: 4px;
    border-radius: 20px;
    min-height: initial !important;

    & > i {
      font-size: inherit;
    }
  }

  &.active {
    font-weight: 550;
    letter-spacing: 0.015rem;
  }
}
</style>
